import { TransactionPaymentSubtype } from "../models/transaction.model";
import { VendingUtils } from "./vending.util";

export class PaymentTypeUtil {
  static getPaymentTypeName(triggerPaymentType) {
    const allTypes = triggerPaymentType?.paymentTypes?.map((types) => {
      const soloType = VendingUtils.getPaymentTypeNameServerSide(types, triggerPaymentType?.paymentMethods);
      if (Array.isArray(soloType)) {
        soloType.map((solo) => {
          return { label: solo, value: solo };
        });
        return soloType;
      } else {
        return { label: soloType, value: types };
      }
    });
    const all = allTypes.concat(
      triggerPaymentType?.walletIndicators.map((types) => {
        const type = VendingUtils.getPaymentTypeNameServerSide(types);
        return { label: type, value: type };
      })
    );
    return all.flat();
  }
}

export const addAmpersandToString = (string1, string2) => {
  if (string1 && string2) {
    return "&";
  } else {
    return "";
  }
};

export const isWalletOrDefault = (paymentType) => {
  var generatePaymentTypeString =
    paymentType
      .map((paymentType) => {
        if (typeof paymentType?.value === "string") {
          if (
            paymentType?.value === TransactionPaymentSubtype.GooglePay ||
            paymentType?.value === TransactionPaymentSubtype.GooglePay2 ||
            paymentType?.value === TransactionPaymentSubtype.GooglePay3 ||
            paymentType?.value === TransactionPaymentSubtype.ApplePay ||
            paymentType?.value === TransactionPaymentSubtype.ApplePay2 ||
            paymentType?.value === TransactionPaymentSubtype.ApplePay3
          ) {
            return `wallet=${VendingUtils.getPaymentTypeNameServerSideReversed(paymentType?.value)}`;
          } else {
            return `paymentMethods=${VendingUtils.getPaymentTypeNameServerSideReversed(paymentType?.value)}`;
          }
        } else {
          return `paymentTypes=${VendingUtils.getPaymentTypeNameServerSideReversed(paymentType?.value)}`;
        }
      })
      .join("&") || "";
  if (generatePaymentTypeString?.includes("paymentMethods") || generatePaymentTypeString?.includes("wallet")) {
    return "paymentTypes=6&" + generatePaymentTypeString;
  }
  return generatePaymentTypeString;
};
